import i18n, { use, type BackendModule } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationDE from './locales/de';

// Deutsch (Standard, fast alle Besucher) liegt im Start-Bundle; Englisch (~0,5 MB) lädt erst,
// wenn es gebraucht wird. i18next wartet bei changeLanguage('en') selbst auf das Laden, und
// useTranslation hält die Seite bis dahin im Suspense-Spinner (kein Aufblitzen auf Deutsch).
const resources = {
  de: {
    translation: translationDE,
  },
};

const lazyLocales: BackendModule = {
  type: 'backend',
  init: () => {},
  read: (language, namespace, callback) => {
    if (language !== 'en' || namespace !== 'translation') {
      callback(null, {});
      return;
    }
    import('./locales/en').then(
      module => callback(null, module.default),
      error => callback(error, null)
    );
  },
};

// eslint-disable-next-line react-hooks/rules-of-hooks
use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(lazyLocales)
  .init({
    // Only check language without region, so "en" instead of "en-GB"
    load: 'languageOnly',
    fallbackLng: 'de',
    // Nur diese beiden Sprachen; alles andere fällt auf Deutsch zurück.
    supportedLngs: ['de', 'en'],
    detection: {
      // Browser melden 'de-DE', 'de-AT', 'en-US' …; i18n.language soll trotzdem 'de' bzw. 'en'
      // sein. Viele Komponenten (u. a. alle Wizard-Panels) prüfen `i18n.language === 'de'` —
      // mit 'de-DE' war das immer falsch und der Wizard blieb bei deutschem Browser englisch.
      convertDetectedLanguage: (language: string) => language.split('-')[0].toLowerCase(),
      // https://github.com/i18next/i18next-browser-languageDetector#detector-options
      // keys or params to lookup language from
      // lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lang',
      order: [
        'querystring',
        'localStorage',
        'navigator',
        // 'cookie',
      ],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources,
    // Mitgelieferte Sprachen nicht neu laden, fehlende über lazyLocales holen.
    partialBundledLanguages: true,

    keySeparator: false, // we do not use keys in form messages.welcome
  });

// <html lang> follows the UI language (screen readers, browser translation, hyphenation).
i18n.on('languageChanged', language => {
  if (typeof document !== 'undefined') document.documentElement.lang = language;
});

export default i18n;

